import React from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import classes from "../../CVs/CvDetails/LinguisticSkills/LinguisticSkill/LinguisticSkill.module.css";
import Grid from "@material-ui/core/Grid";


const EditCard = (props) => {
    return (
        <div className={classes.linguisticSkill}>
            <Card key={props.index}>
                < CardHeader
                    titleTypographyProps={{variant: 'h6'}}
                    title={props.title} subheader=""/>
                <Grid style={{paddingRight: '20px', paddingLeft: '20px'}} container spacing={3}>
                    <Grid item xs={12}>
                        {props.content}
                    </Grid>
                    <Grid item xs={1}/>
                </Grid>
            </Card>
        </div>
    );
};

export default EditCard;
